/* Enso — more bulbs (15 Sep 2026, concept A).
   The buy-box bulb tile shows the cheapest compatible bulb. snippets/epc-keys.liquid
   emits a hidden ".epc__morebulbs" row and a "#epcm-bulbs" drawer listing every
   compatible bulb. This moves the row into the bulb tile (under the BULBS stepper)
   and, when a bulb is picked in the drawer, swaps the tile in place: variant id,
   price, image, name, spec line and the (i) details target. The section's own
   paint() runs off the checkbox "change" event, so totals and the CTA follow.
   Elements are moved, not cloned — the section's listeners survive. */
(function () {
  function init() {
    var link = document.querySelector('.epc__morebulbs');
    var cb = document.querySelector('.epc__add [data-bulb-cb]');
    if (!link || !cb) return;
    var row = cb.closest('.epc__add');
    if (!row) return;
    /* The drawers are emitted inside .epc__buy, which is position:relative with
       z-index 2 — a stacking context that trapped them under the fixed header and
       the phone thumbnail strip. Move them up to the section root (#epc), where the
       section's own (i) drawer lives and its [data-epc-open] delegation still runs. */
    var root = document.getElementById('epc');
    if (root) {
      var panels = document.querySelectorAll('#epcm-bulbs, .epc__dw[id^="epcm-bulb-"]');
      for (var p = 0; p < panels.length; p++) root.appendChild(panels[p]);
    }
    row.appendChild(link);
    link.hidden = false;

    var img = row.querySelector('.epc__addimg');
    var nameEl = row.querySelector('.epc__addmain b');
    var specEl = row.querySelector('.epc__addmain small');
    var info = row.querySelector('.epc__addinfo');
    var label = link.querySelector('span');
    var count = Number(link.getAttribute('data-count') || 0);
    var cap = link.getAttribute('data-cap') || '';
    var minAll = link.getAttribute('data-min') || '';

    document.addEventListener('click', function (e) {
      var opt = e.target.closest ? e.target.closest('[data-bulb-pick]') : null;
      if (!opt) return;
      e.preventDefault();
      var opts = document.querySelectorAll('[data-bulb-pick]');
      for (var i = 0; i < opts.length; i++) {
        var on = opts[i] === opt;
        opts[i].classList.toggle('is-on', on);
        opts[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      var name = opt.getAttribute('data-name') || '';
      cb.setAttribute('data-vid', opt.getAttribute('data-vid'));
      cb.setAttribute('data-cents', opt.getAttribute('data-cents'));
      if (img && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
      if (nameEl) nameEl.textContent = name;
      if (specEl) specEl.textContent = opt.getAttribute('data-spec') || '';
      if (info) {
        info.setAttribute('data-epc-open', opt.getAttribute('data-mid'));
        info.setAttribute('aria-label', 'Details for ' + name);
      }
      if (!cb.checked) cb.checked = true;
      cb.dispatchEvent(new Event('change', { bubbles: true }));
      if (label) label.textContent = 'Change bulb · ' + count + ' ' + cap + ' bulbs fit this light';
      var small = link.querySelector('small');
      if (small && minAll) small.textContent = 'from ' + minAll + ' →';
      var close = document.querySelector('#epcm-bulbs [data-epc-close]');
      if (close) close.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
